import { render, staticRenderFns } from "./PopupAddGuestListItem.vue?vue&type=template&id=48c08972&scoped=true&"
import script from "./PopupAddGuestListItem.vue?vue&type=script&lang=js&"
export * from "./PopupAddGuestListItem.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddGuestListItem.vue?vue&type=style&index=0&id=48c08972&prod&lang=scss&scoped=true&"
import style1 from "./PopupAddGuestListItem.vue?vue&type=style&index=1&id=48c08972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c08972",
  null
  
)

export default component.exports